import Button from 'components/_parts/atoms/button';
import LoadingCustom from 'components/layouts/loading/loading';
import { useOuterClick } from 'providers/OutsideClick';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import ModalCustomWla from '../modal';
import Collapsible from './collapsible';

interface PropsType {
  t: (e:string) => string
}

const ButtonMod = styled(Button)`
  width: 100%;
  height: 24px;
  float: right;
`;

function Index(props: PropsType) {
  const { t } = props;
  const [showModal, setShowModal] = useState(false);
  const [id, setId] = useState(null);
  const [typeForm, setTypeForm] = useState('');
  const { classificationList, keyClassification } = useSelector((state) => ({
    classificationList: state?.wla?.other_category_list,
    keyClassification: state?.loading?.listKey?.companyClassification,
  }));
  const [selectedData, setSelectedData] = useState({});
  const [category, setCategory] = useState('');
  const [activeCollapsible, setActiveCollapsible] = useState('');

  const innerRef = useOuterClick((e) => {
    if (
      e?.srcElement?.className && (e.srcElement?.className === 'modal fade show'
          || e.srcElement?.className?.includes('cs_modal-bg'))
    ) {
      setShowModal(false);
      setId(null);
    }
  });

  return (
    <>
      {showModal && (
      <ModalCustomWla
        innerRef={innerRef}
        modal={showModal}
        funcModal={setShowModal}
        ids={id}
        category={category}
        data={selectedData}
        funcId={() => setId}
        typeForm={typeForm}
        t={t}
      />
      )}
      <div
        className="tab-pane active position-relative"
        id="custom_wla_list"
        role="tabpanel"
        style={{
          minHeight: '700px',
        }}
      >
        { keyClassification ? <LoadingCustom style={{ height: '100px' }} /> : (
          <>
            <div className="row">
              <div className="col-8">
                <h4 className="title">{t('company.wla_category')}</h4>
              </div>
              <div className="col-4">
                <ButtonMod
                  icon="create"
                  func={() => {
                    setShowModal(true);
                    setTypeForm('create');
                  }}
                >
                  &nbsp;&nbsp;
                  {t('company.add_category')}
                </ButtonMod>
              </div>
            </div>
            <div className="layoutListWla scrollCategory">
              {classificationList.length === 0
              && (
                <div className="textEmptyData" style={{ color: 'black' }}>
                  {t('wla.status.not_found')}
                </div>
              )}
              {classificationList.length > 0
              && (
              <Collapsible
                {...props}
                setShowModal={setShowModal}
                setTypeForm={setTypeForm}
                setId={setId}
                activity_type_list_={classificationList}
                setSelectedData={setSelectedData}
                setCategory={setCategory}
                activeCollapsible={activeCollapsible}
                setActiveCollapsible={setActiveCollapsible}
              />
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default Index;
